module.exports = __webpack_public_path__ + "img/i_key_05.2b6a81e3.svg";